import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideoModal from '@/components/UI/EFVideoModal';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/i18n';

const A: React.FC = () => {
    const { t } = useLang('dpux');
    const { locale } = getLocal();
    const [isM, setIsM] = useState<boolean>(false);
    const [enter, setEnter] = useState(false);
    const [youtube, setYoutube] = useState<string>('');

    const handlePlay = () => {
        setYoutube('https://www.youtube.com/embed/T5ucOsi-EQM?si=wpAGw1427fxwuTDQ');
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('A_title'),
            position: 'Product Detail_1',
            __btn_id1: css.section,
            __btn_id2: t('A_btn'),
        });
    };

    useEffect(() => {
        setIsM(window.innerWidth < 1024);
        if (typeof window !== 'undefined') {
            const st = setTimeout(() => {
                setEnter(true);
            }, 1000);
            return () => {
                clearTimeout(st);
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-A GtmModuleData-section`}
            id="delta-pro-ultra-x-A"
            data-section-id={'delta-pro-ultra-x-A'}
            data-section-title={t('A_title')}
        >
            <div className="img">
                <picture>
                    <source
                        srcSet={
                            isM
                                ? 'https://websiteoss.ecoflow.com/upload/image/1758938952394/m_kv.webp'
                                : 'https://websiteoss.ecoflow.com/upload/image/1758938945615/pc_kv.webp'
                        }
                        type="image/webp"
                    />
                    <img
                        fetchPriority="high"
                        src={
                            isM
                                ? 'https://websiteoss.ecoflow.com/upload/image/1758938719395/m_kv.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1758938719651/pc_kv.jpg'
                        }
                        alt={t('A_title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className={`info ${enter ? 'enter' : ''}`}>
                <div className={`inner`}>
                    {/* <div className="label">{t('A_label')}</div> */}
                    <div className={`title ani-1 ${enter ? ' enter' : ''}`}>{t('A_title')}</div>
                    <p className={`desc ani-2 ${enter ? ' enter' : ''}`}>
                        {t.rich('A_desc', {
                            s: (s) => <span className="s">{s}</span>,
                        })}
                    </p>
                    {locale === 'us' && (
                        <div className={`btn GtmModuleData-btn-text ani-3 ${enter ? ' enter' : ''}`} onClick={handlePlay}>
                            <span>{t('A_btn')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 0C18.4188 9.184e-05 23.6219 5.20325 23.6221 11.6221C23.6221 18.0411 18.419 23.245 12 23.2451C5.58094 23.2451 0.376953 18.0411 0.376953 11.6221C0.377169 5.2032 5.58108 0 12 0ZM10.5996 7.25488C10.2154 6.97769 9.67902 7.25189 9.67871 7.72559V15.5195C9.67878 15.9935 10.2153 16.2676 10.5996 15.9902L15.999 12.0938C16.3204 11.8618 16.3204 11.3833 15.999 11.1514L10.5996 7.25488Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    )}
                </div>
            </div>
            <EFVideoModal visible={Boolean(youtube)} source={youtube} onClose={() => setYoutube('')} playerType={'YouTube'} />
        </section>
    );
};

export default A;
